<template>
  <div class="ccui-error-405-main">
    <div class="ccui-error-405__pic">
      <img
        src="@/basa/assets/305_images/305.png"
        alt="405"
        width="579px"
        height="291px"
      />
    </div>
    <div class="ccui-error-405-detail">
      <div
        class="ccui-error-405-detail-text"
        v-html="$store.state.app.routerPower.message"
      ></div>
      <div class="ccui-error-405-detail-button">
        <el-button type="primary" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error405",
  data() {
    return {};
  },
  methods: {
    goBack() {
      window.location.href = this.$addUrlPerFix(process.env.VUE_APP_EMP_URL);
    }
  }
};
</script>
